import React, { Component } from "react";
import { withRouter } from "react-router-dom";

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

class AuthVerify extends Component {
  constructor(props) {
    super(props);

    props.history.listen(() => {
      const token = localStorage.getItem("token");

      if (token) {
        const decodedJwt = parseJwt(token);
        // console.log("token expired?", decodedJwt.exp * 1000 < Date.now());
        const TIME_DURATION = 30 * 60 * 1000;
        setTimeout(() => {
          props.logout();
        }, TIME_DURATION);
        // if (decodedJwt.exp * 1000 < Date.now()) {
        // (async function () {
        //     console.log("DISPATCH");
        //       await dispatch(muchAndLearnMngtThunk.sessonExpred(true));
        // })();
        // }
      }
    });
  }

  render() {
    return <div></div>;
  }
}

// setTimeout(async () => {
//   console.log("ALERTTTTTTTTTT");
//   props.logout();
// }, 10000);

export default withRouter(AuthVerify);



// WEBPACK FOOTER //
// ./src/common/Auth.verify.js